import { SITE, values } from "../data";
import SectionHeading from "./SectionHeading";

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <SectionHeading
              eyebrow="About the contest"
              title="什么是黑料大赛？"
              desc="黑料大赛不是揭短，也不是吃瓜。我们把它定义为一档「自我调侃」的线上赛事——把那些让你想原地消失的瞬间，变成能让所有人会心一笑的作品。"
            />
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              赛事自创办以来已连续举办多季，累计收到超过十万件来自不同城市、不同职业的投稿。
              有人分享菜市场认错人的尴尬，有人复盘面试时嘴瓢的现场，也有人把一段走神的恋爱经历写成短剧。
              它们有一个共同点：主角都是投稿者自己。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们希望这里是一个安全的表达场：你可以尽情自嘲，但没有人会因为你讲得真实而被冒犯。
              这也是{SITE.brand}最核心的那条底线——<strong className="text-foreground-900">只黑自己，不黑别人</strong>。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="#judge"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-foreground-950 hover:bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap transition-colors"
              >
                了解评选标准
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
              <a
                href="#stories"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-background-300 hover:border-primary-400 hover:text-primary-600 text-foreground-800 text-sm font-medium whitespace-nowrap transition-colors"
              >
                看往期精选
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="w-full h-[260px] sm:h-[340px] lg:h-[460px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20friendly%20audience%20gathering%20around%20a%20glowing%20microphone%20on%20a%20cozy%20stage%2C%20warm%20amber%20and%20terracotta%20palette%2C%20soft%20geometric%20shapes%2C%20clean%20minimal%20composition%2C%20festive%20yet%20calm%20mood%2C%20no%20text%2C%20editorial%20magazine%20style%2C%20warm%20cream%20background&width=1000&height=800&seq=hl-about-01&orientation=landscape"
                alt="观众围坐在温暖舞台上聆听分享的场景插画"
                title="黑料大赛 · 观众与舞台场景"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {values.map((item) => (
            <article
              key={item.title}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}